module.exports = __webpack_public_path__ + "img/c12.f9cd2f51.png";